import type { ResponseGetCdtCategoryTrees } from "@CommonApi/cdt/categories/_categoryId_/trees";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { fetchCdtCategoryTrees } from "./cdtTreeService";

export const CDT_CATEGORY_TREES_QUERY_KEY = (categoryId?: number) =>
  ["cdt-category-trees", categoryId] as const;

export const useCdtCategoryTreesQuery = (
  categoryId?: number,
): UseQueryResult<ResponseGetCdtCategoryTrees> =>
  useQuery({
    queryKey: CDT_CATEGORY_TREES_QUERY_KEY(categoryId),
    queryFn: () => {
      if (categoryId === undefined) throw new Error("CategoryId is required");
      return fetchCdtCategoryTrees(categoryId);
    },
    enabled: categoryId !== undefined && categoryId > 0,
  });
